// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x80Y_LltA5PliUAZlphe {
  width: 4.5rem;
}

.x80Y_LltA5PliUAZlphe:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/UserLogOut/UserLogOut.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AACA;EACE,eAAA;AAEF","sourcesContent":[".UserLogOut {\n  width: 4.5rem;\n}\n.UserLogOut:hover {\n  cursor: pointer;\n}\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"UserLogOut": `x80Y_LltA5PliUAZlphe`
};
export default ___CSS_LOADER_EXPORT___;
